// Element class setup
const classModal = ".products-grid-modal";
const classModalOpen = '.products-grid-modal[data-state="open"]';
const classGridBlock = '.products-grid__block';
const classModalButtonOpen = ".products-grid__button";
const classModalContent = '.products-grid-modal__container';
const classModalButtonClose = ".products-grid-modal__button";
const classModalPrev = ".products-grid-modal__arrow-prev";
const classModalNext = ".products-grid-modal__arrow-next";

// Fetch modal elements
const modalArray = Array.from(document.querySelectorAll(classModal)); 
const modalPrevArray = Array.from(document.querySelectorAll(classModalPrev));
const modalNextArray = Array.from(document.querySelectorAll(classModalNext));
const modalOpenArray = Array.from(document.querySelectorAll(classModalButtonOpen)); 
const modalCloseArray = Array.from(document.querySelectorAll(classModalButtonClose)); 
const modalContainerArray = Array.from(document.querySelectorAll(classModalContent));

// Fetch modal forms
const classModalForm = '.products-grid-modal__product-form';
const modalFormArray = Array.from(document.querySelectorAll(classModalForm));

// Function update cart endpoint
function updateCartEndpoint() {
  const rootURL = "https://cloudb.com/";
  const currentPath = window.location.href.replace(rootURL, "");
  const pathLocale = currentPath.split("/")[0];

  let endpointLocale = "";
  let endpointCart = "/cart/add";
  
  console.log("Current Path: ", currentPath);
  console.log("Path Locale: ", pathLocale);

  if (pathLocale.includes("?")) {
    endpointLocale = pathLocale.split("?")[0];
  } else if(pathLocale !== "" && pathLocale !== "collections" && pathLocale !== "products") {
    endpointLocale = "/" + pathLocale;
  }
  
  console.log("Endpoint Locale: ", endpointLocale);
  
  const endpoint = endpointLocale + endpointCart;
  
  console.log("Endpoint: ", endpoint);
  
  modalFormArray.forEach(modalForm => {
    modalForm.setAttribute('action', endpoint);
  })
}

updateCartEndpoint();

// Attach event listeners to modal container to prevent default behavior
if(modalContainerArray) {
    modalContainerArray.forEach(item => {
        item.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
        })
    })
}

// Attach event listener to modal overlays 
if(modalArray) {
    modalArray.forEach(item => {
        item.addEventListener('click', () => { closeModal(item) });
    })
}

// Attach event listeners to elements to open modal
if(modalOpenArray) {
    modalOpenArray.forEach(item => { 
        item.addEventListener('click', () => { openModal(item) });
    })
}

// Attach event listeners to elements to close modal
if(modalCloseArray) {
    modalCloseArray.forEach(item => {
        item.addEventListener('click', () => { closeModal(item) });
    })
}

// Attach event listeners to elements to swap to previous modal
if (modalPrevArray) {
    modalPrevArray.forEach(button => {
        button.addEventListener('click', () => { changeModal(-1) })
    })
}

// Attach event listeners to elements to swap to next modal
if (modalNextArray) {
    modalNextArray.forEach(button => {
        button.addEventListener('click', () => { changeModal(1) })
    })
}

function closeModal(target) {
    let modal;

    if (modalArray && modalArray.includes(target)) {
        modal = target;
        console.log(modal)
    }else {
        modal = target.parentNode.parentNode;
    }

    if(!modal) return;

    if (modal.getAttribute('data-state') === 'open') {
        modal.setAttribute('data-state', 'closing')
        modal.addEventListener('animationend', () => {
            modal.setAttribute('data-state', 'closed')
        }, { once: true });
    }
}

function openModal(target) {
    const modal = target.closest(classGridBlock).querySelector(classModal);

    if (!modal) return;

    if (modal.getAttribute('data-state') === 'closed') {
        modal.setAttribute('data-state', 'open')
    }
}

// Changes displayed modal on arrow click,
// Modifier 1 for next modal
// Modifier -1 for prev modal
function changeModal(modifier) {
    if (!modalArray) return; // Quit if there are no modals

    const currentIndex = modalArray.indexOf(document.querySelector(classModalOpen));
    const currentCount = modalArray.length;

    modalArray[currentIndex].setAttribute('data-state', 'closing');
    modalArray[currentIndex].addEventListener('animationend', () => {
        modalArray[currentIndex].setAttribute('data-state', 'closed')
    }, { once: true });

    if (modifier == 1) {
        if (currentIndex == currentCount - 1) {
            modalArray[0].setAttribute('data-state', 'open');
        }else {
            modalArray[currentIndex + 1].setAttribute('data-state', 'open');
        }
    } else if (modifier == -1) {
        if (currentIndex == 0) {
            modalArray[currentCount - 1].setAttribute('data-state', 'open');
        }else {
            modalArray[currentIndex - 1].setAttribute('data-state', 'open');
        }
    }
}